import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';

const influencerItemSelector = item => item;

const mapProductsFilters = filters => ([{
  condition: 'or',
  group: filters.map(f => ({
    field: f.field,
    value: f.value,
    operator: f.operator,
  })),
}]);

const filtersSelector = createSelector(
  influencerItemSelector,
  item => (!isEmpty(item)
    ? mapProductsFilters([
      ...item.page.productSection.filters || [],
      ...item.page.productSection.selectedProductsFilters || [],
    ])
    : []),
);

export const productsMappedFiltersSelector = createSelector(
  filtersSelector,
  mappedFilters => (mappedFilters),
);

export default {
  productsMappedFiltersSelector,
};
